document.addEventListener('DOMContentLoaded', function (event) {
    //Dropdown
    const dropdownItems = document.querySelectorAll('.dropdown');

    function findParentByClass(element, className) {
        if (element.classList.contains(className)) return element;

        const parent = element.parentElement;
        if (!parent) return null;

        return findParentByClass(parent, className);
    }

    function menuItemToggle(dropdownItems) {
        if (window.innerWidth >= 768) {
            dropdownItems.forEach(function (dropdownItem) {
                const dropdownToggle = dropdownItem.querySelector('.dropdown-toggle');

                const dropdownMenu = dropdownItem.querySelector('.dropdown-menu');
                const dropdownToggleButton = dropdownItem.querySelector('.nav-dropdown-button');

                let _dropdown_opened_via_keyboard = false;

                dropdownItem.addEventListener('_open-dropdown', function (event) {
                    dropdownToggle.classList.add('show');
                    dropdownToggle.setAttribute('aria-expanded', 'true');
                    dropdownMenu.classList.add('show');
                    dropdownToggleButton.querySelector('.visually-hidden.open-text').classList.add('d-none');
                    dropdownToggleButton.querySelector('.visually-hidden.closed-text').classList.remove('d-none');
                });

                dropdownItem.addEventListener('_close-dropdown', function (event) {
                    event.target.classList.remove('show');
                    event.target.setAttribute('aria-expanded', 'false');
                    dropdownMenu.classList.remove('show');
                    _dropdown_opened_via_keyboard = false;
                    dropdownToggleButton.classList.remove('opened-via-keyboard');
                    dropdownToggleButton.setAttribute('aria-pressed', 'false');
                    dropdownToggleButton.querySelector('.visually-hidden').textContent = 'Subnavigation ausklappen';
                    dropdownToggleButton.querySelector('.visually-hidden.open-text').classList.remove('d-none');
                    dropdownToggleButton.querySelector('.visually-hidden.closed-text').classList.add('d-none');
                });

                const dropDownItemsArr = Array.from(dropdownMenu.querySelectorAll('a.dropdown-item'));
                dropDownItemsArr.at(-1).addEventListener('focusout', function (event) {
                    if (event.relatedTarget != dropDownItemsArr.at(-2)) {
                        dropdownItem.dispatchEvent(new Event('_close-dropdown'));
                    }
                });

                dropdownToggleButton.addEventListener('focusout', function (event) {
                    if (event.relatedTarget == dropdownToggle) {
                        dropdownItem.dispatchEvent(new Event('_close-dropdown'));
                    }
                });

                /* --- */

                dropdownToggleButton.addEventListener('keydown', function (event) {
                    if (event.key != 'Enter' && event.key != ' ') return;
                    _dropdown_opened_via_keyboard = true;
                    dropdownToggleButton.setAttribute('aria-pressed', 'true');
                    dropdownToggleButton.classList.add('opened-via-keyboard');

                    const _is_open = dropdownItem
                        .querySelector('.dropdown-menu')
                        .classList
                        .contains('show');


                    setTimeout(() => {
                        dropdownItem
                            .dispatchEvent(new Event(_is_open ? '_close-dropdown' : '_open-dropdown'));
                    }, 0);
                });

                dropdownItem.addEventListener('mouseover', function (event) {
                    dropdownItem.dispatchEvent(new Event('_open-dropdown'));

                    if (dropdownItem.timeout) clearTimeout(dropdownItem.timeout);
                });

                dropdownItem.addEventListener('mouseout', function (event) {
                    dropdownItem.timeout = setTimeout(function () {
                        if (_dropdown_opened_via_keyboard) return;
                        dropdownItem.dispatchEvent(new Event('_close-dropdown'));
                    }, 100);
                });

                document.body.addEventListener('click', function (event) {
                    if (!findParentByClass(event.target, 'navbar-nav')) {
                        document.querySelectorAll('.dropdown').forEach(function (dropdownItem) {
                            dropdownItem.dispatchEvent(new Event('_close-dropdown'));
                        });
                    }
                });
            });
        } else {
            dropdownItems.forEach(function (dropdownItem) {
                const dropdownToggle = dropdownItem.querySelector('.dropdown-toggle');
                const dropdownMenu = dropdownItem.querySelector('.dropdown-menu');

                dropdownToggle.addEventListener('click', function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                    dropdownToggle.classList.toggle('show');
                    dropdownMenu.classList.toggle('show');

                    if (dropdownToggle.getAttribute('aria-expanded') === 'true') {
                        dropdownToggle.setAttribute('aria-expanded', 'false');
                    } else {
                        dropdownToggle.setAttribute('aria-expanded', 'true');
                    }
                });
            });
        }
    }

    menuItemToggle(dropdownItems);

    initDesktopNavigation(dropdownItems);

    //Mobile Nav Toggler
    const mainNav = document.getElementById('navbarNavDropdown');
    const navToggle = document.getElementsByClassName('navbar-toggler');

    function mainNavToggle() {
        mainNav.classList.toggle('collapsed');
        navToggle[0].classList.toggle('clicked');

        if (navToggle[0].getAttribute('aria-expanded') === 'true') {
            navToggle[0].setAttribute('aria-expanded', 'false');
        } else {
            navToggle[0].setAttribute('aria-expanded', 'true');
        }
    }

    navToggle[0].addEventListener('click', mainNavToggle);

    document.querySelectorAll('.shortcut').forEach(function (shortcutItem) {
        shortcutItem.addEventListener('click', function (event) {
            event.preventDefault();
        });
    });
});


function initDesktopNavigation(dropdownItems) {
    if (window.innerWidth >= 992) {

        dropdownItems.forEach(function (dropdownItem) {
            const dropdownToggle = dropdownItem.querySelector('.dropdown-toggle');
            const dropdownMenu = dropdownItem.querySelector('.dropdown-menu');

            dropdownToggle.classList.remove('show');
            dropdownToggle.setAttribute('aria-expanded', 'false');
            dropdownMenu.classList.remove('show');
            dropdownMenu.style.display = '';
        });
    }
}
function initMobileNavigation(dropdownItems) {
    if (window.innerWidth < 992) {

        dropdownItems.forEach(function (dropdownItem) {
            const dropdownToggle = dropdownItem.querySelector('.dropdown-menu.active .dropdown-toggle');
            const dropdownMenu = dropdownItem.querySelector('.dropdown-menu.active .dropdown-menu');

            dropdownToggle?.classList.add('show');
            dropdownToggle?.setAttribute('aria-expanded', 'true');
            dropdownMenu?.classList.add('show');

        });
    }
}

// resize window
window.addEventListener('resize', function (event) {

    //Dropdown
    const dropdownItems = document.querySelectorAll('.dropdown');
    initDesktopNavigation(dropdownItems);
    initMobileNavigation(dropdownItems);
});